import React, { createContext, useState } from "react";
export const SidebarContext = createContext(null);
export const SidebarProvider = ({ children = void 0 }) => {
  const [sidebar, setSidebar] = useState(null);
  const clearSidebar = () => {
    setSidebar(null);
  };
  return /* @__PURE__ */ React.createElement(SidebarContext.Provider, { value: { sidebar, clearSidebar, setSidebar } }, children);
};
